var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["core-video-icon.j2"] = require( "core-video-icon.j2" );
dependencies["macros/ugc-tile-like-hearts.j2"] = require( "macros/ugc-tile-like-hearts.j2" );
dependencies["contentful/ugc-heart-toggle.j2"] = require( "contentful/ugc-heart-toggle.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/ugc-tile-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/ugc-tile-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productUrl")) {
var t_4 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_4);
if(t_1.hasOwnProperty("imageUrl")) {
var t_5 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_5);
var macro_t_6 = runtime.makeMacro(
["item"], 
["tileTemplate", "index", "isClickedTile", "displayHearts", "navigationId"], 
function (l_item, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("item", l_item);
frame.set("tileTemplate", kwargs.hasOwnProperty("tileTemplate") ? kwargs["tileTemplate"] : "DEFAULT");
frame.set("index", kwargs.hasOwnProperty("index") ? kwargs["index"] : 0);
frame.set("isClickedTile", kwargs.hasOwnProperty("isClickedTile") ? kwargs["isClickedTile"] : false);
frame.set("displayHearts", kwargs.hasOwnProperty("displayHearts") ? kwargs["displayHearts"] : false);
frame.set("navigationId", kwargs.hasOwnProperty("navigationId") ? kwargs["navigationId"] : "");
var t_7 = "";var t_8;
t_8 = runtime.memberLookup((l_item),"user");
frame.set("user", t_8, true);
if(frame.topLevel) {
context.setVariable("user", t_8);
}
if(frame.topLevel) {
context.addExport("user", t_8);
}
t_7 += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"isHearts") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"isUploads")) {
t_7 += "\n\n        ";
var t_9;
t_9 = runtime.memberLookup((runtime.memberLookup((l_item),"photo")),"small_square");
frame.set("thumb", t_9, true);
if(frame.topLevel) {
context.setVariable("thumb", t_9);
}
if(frame.topLevel) {
context.addExport("thumb", t_9);
}
t_7 += "\n\n    ";
;
}
else {
t_7 += "\n\n        ";
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((l_item),"photo")),"medium_square");
frame.set("thumb", t_10, true);
if(frame.topLevel) {
context.setVariable("thumb", t_10);
}
if(frame.topLevel) {
context.addExport("thumb", t_10);
}
t_7 += "\n\n    ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "TILE_WITH_HOVER") {
t_7 += "\n\n        <div class=\"c-ugc-tile o-column o-extra-small--6 o-medium--3 o-large--2 ";
if(runtime.contextOrFrameLookup(context, frame, "isClickedTile") == true) {
t_7 += " c-ugc-tile--active ";
;
}
t_7 += " js-ugc-tile\"\n             data-tile-index=\"";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_7 += "\" data-qa-number-of-linked-products=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_item),"product_ids")),"length"), env.opts.autoescape);
t_7 += "\" data-qa-ugc-tile\n             data-pic-id=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((l_item),"id"), env.opts.autoescape);
t_7 += "\"\n             ";
t_7 += runtime.suppressValue((lineno = 36, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc image",env.getFilter("string").call(context, runtime.memberLookup((l_item),"id"))])), env.opts.autoescape);
t_7 += ">\n\n            <div class=\"c-ugc-tile__image-outer\">\n\n                <img class=\"c-ugc-tile__image\" src=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "thumb")),"url"), env.opts.autoescape);
t_7 += "\" alt=\"\" />\n\n                ";
if(runtime.memberLookup((l_item),"video")) {
t_7 += "\n\n                    <span class=\"c-ugc-tile__video-icon\">\n\n                        ";
env.getTemplate("core-video-icon.j2", false, "core/templates/macros/ugc-tile-macro.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_7 += t_12
t_7 += "\n\n                    </span>\n\n                ";
})});
}
t_7 += "\n\n                <div class=\"c-ugc-tile__details\">\n\n                    <div class=\"c-ugc-tile__inner\">\n\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"isUploads")) {
t_7 += "\n\n                            ";
t_7 += runtime.suppressValue((lineno = 58, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_upload_" + runtime.memberLookup((l_item),"status")])), env.opts.autoescape);
t_7 += "\n\n                        ";
;
}
else {
t_7 += "\n\n                            ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"username")) > 0) {
t_7 += "\n\n                                <p class=\"c-ugc-tile__p c-ugc-tile__line-one\">\n\n                                    <img class=\"c-ugc-tile__user-image\" src=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"small_square")),"url"), env.opts.autoescape);
t_7 += "\" alt=\"\" />\n\n                                    ";
t_7 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"username"), env.opts.autoescape);
t_7 += "\n\n                                </p>\n\n                                <p class=\"c-ugc-tile__p c-ugc-tile__line-two\">\n\n                                    ";
env.getTemplate("macros/ugc-tile-like-hearts.j2", false, "core/templates/macros/ugc-tile-macro.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_7 += t_16
t_7 += "\n\n                                </p>\n\n                            ";
})});
}
t_7 += "\n\n                            <p class=\"c-ugc-tile__button c-button-secondary\">\n\n                                ";
t_7 += runtime.suppressValue((lineno = 82, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_shop-link"])), env.opts.autoescape);
t_7 += "\n\n                            </p>\n\n                        ";
;
}
t_7 += "\n\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>";
;
}
else {
t_7 += "\n\n        <div class=\"c-ugc-tile o-column o-extra-small--6 o-medium--3 o-large--2\"\n             data-pic-id=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((l_item),"id"), env.opts.autoescape);
t_7 += "\">\n\n            <div class=\"c-ugc-tile__image-outer\">\n\n                ";
env.getTemplate("contentful/ugc-heart-toggle.j2", false, "core/templates/macros/ugc-tile-macro.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
t_7 += t_20
t_7 += "\n\n                <img src=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "thumb")),"url"), env.opts.autoescape);
t_7 += "\" alt=\"\" />\n\n            </div>\n\n        </div>\n\n    ";
})});
}
;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
context.addExport("displayUgcTile");
context.setVariable("displayUgcTile", macro_t_6);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/ugc-tile-macro.j2"] , dependencies)